module.exports = __webpack_public_path__ + "static/Topper-4d0b3e7588c3e715947562dfe2bda585.png";